<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  imageSrc?: string
  customClass?: string
  firstName: string
  imageClass?: string
  outerBorderStyle?: boolean
}>(), {
  imageSrc: '',
  customClass: undefined,
  imageClass: undefined,
  outerBorderStyle: true,
})

const profileImage = computed(() => {
  if (props.imageSrc) return props.imageSrc
  const firstLetter = props.firstName[0].toLowerCase()
  if (/[a-z0-9]/.test(firstLetter)) return new URL(`/src/assets/stickers/festive-flags/${firstLetter}.gif`, import.meta.url).href
  return new URL(`/src/assets/stickers/festive-flags/rainbow.gif`, import.meta.url).href
})

</script>
<template>
  <div
    :class="twMerge('rounded-full',
                    outerBorderStyle && (imageSrc ? 'outline outline-1 outline-offset-[-1px] outline-white/30' : ''),
                    customClass)"
  >
    <img
      :src="profileImage"
      alt="Player profile"
      :class="twMerge('rounded-full w-full h-full object-cover', imageClass)"
    >
  </div>
</template>
